import useLogoutMutation from '@input-web/modules/user/hooks/mutations/use-logout-mutation.hook';
import useScoringStandardListQuery from '../../hooks/queries/use-scoring-standard-list-query.hook';
import useStandardDetailLayoutParams from '../../hooks/ui-handlers/use-standard-detail-layout-params.hook';
import useStandardSearchState from '../../hooks/ui-handlers/use-standard-search-state.hook';
import useSubjectUniversityOptionList from './hooks/queries/use-subject-university-option-list.hook';
import useStandardDialog from './hooks/ui-handlers/use-standard-dialog.hook';
import useStandardLayoutFilter from './hooks/ui-handlers/use-standard-layout-filter.hook';
import useStandardLayoutMenu from './hooks/ui-handlers/use-standard-layout-menu.hook';
import useStandardLayoutNavbarHandler from './hooks/ui-handlers/use-standard-layout-navbar.hook';

export default function useStandardLayoutViewModel() {
  // #region Dependencies
  const logout = useLogoutMutation();
  const standardSearchState = useStandardSearchState();
  const standardDetailLayoutParams = useStandardDetailLayoutParams();
  // #endregion

  // #region Queries
  const subjectUniversityOptionList = useSubjectUniversityOptionList();
  // #endregion

  // #region Handlers
  const navbar = useStandardLayoutNavbarHandler(logout.handleLogout);
  const filter = useStandardLayoutFilter({
    onSearchStateChange: standardSearchState.handleNavigate,
    optionList: subjectUniversityOptionList.data,
    searchState: standardSearchState.state,
  });
  const dialog = useStandardDialog();
  // #endregion

  // #region Standard List
  const scoringStandardList = useScoringStandardListQuery(standardSearchState.state);
  // #endregion

  // #region Menu Handler
  const menu = useStandardLayoutMenu({
    partIdParam: standardDetailLayoutParams.params?.partId,
    standardList: scoringStandardList.data,
  });
  // #endregion

  return { dialog, filter, menu, navbar, standardSearchState };
}
